import { Lightning, Storage } from "@lightningjs/sdk";
import { List } from "@lightningjs/ui";
import { SettingsLanguage } from "./SettingsMain/SettingsLanguage";
import { SettingsAuth } from "./SettingsMain/SettingsAuth";
import { SettingsSubscription } from "./SettingsMain/SettingsSubscription";
import { SettingsParentalControl } from "./SettingsMain/SettingsParentalControl";
import { SettingsAgeRestriction } from "./SettingsMain/SettingsAgeRestriction";
import { SettingsTerms } from "./SettingsInfo/SettingsTerms";
import { SettingsPrivacy } from "./SettingsInfo/SettingsPrivacy";
import { SettingsContact } from "./SettingsInfo/SettingsContact";
import { SettingsItemContainer } from "../../Settings";
import { isExternalPlatform, isPostTvPlatform, STORAGE_KEYS } from "../../../../lib/utils";
import theme from "../../../../lib/theme";
import configs from "../../../../lib/configs";

interface SettingsMainListTemplateSpec extends Lightning.Component.TemplateSpec {
    List: typeof List;
}

interface SettingsMainListTypeConfig extends Lightning.Component.TypeConfig {
    IsPage: true;
}

export class SettingsMainList
    extends Lightning.Component<SettingsMainListTemplateSpec, SettingsMainListTypeConfig>
    implements Lightning.Component.ImplementTemplateSpec<SettingsMainListTemplateSpec>
{
    static override _template(): Lightning.Component.Template<SettingsMainListTemplateSpec> {
        return {
            collision: true,
            w: (w) => w,
            List: {
                collision: true,
                w: (w: number) => w / 2,
                flexItem: { marginTop: 37 },
                x: 0,
                type: List,
                direction: "column",
                signals: { onIndexChanged: true }
                // spacing: 64
            }
        };
    }

    readonly List = this.getByRef("List")!;

    override _getFocused() {
        return this.List;
    }

    override _setup() {
        for (const wrapper of this.List.children) {
            wrapper?.patch({
                collision: true
            });
        }

        const items: any[] = [{ type: SettingsItemContainer, content: SettingsLanguage }];

        // if (configs.playback.audioLanguages) {
        //     items.push({ type: SettingsItemContainer, content: SettingsAudioLanguage });
        // }
        //
        // if (configs.playback.subtitleLanguages) {
        //     items.push({ type: SettingsItemContainer, content: SettingsSubLanguage });
        // }

        if (!isPostTvPlatform() && Storage.get(STORAGE_KEYS.user)?.userManagement !== false && !configs?.freeMode ) {
            if (!isExternalPlatform()) {
                items.push({ type: SettingsItemContainer, content: SettingsSubscription });
            }

            items.push({ type: SettingsItemContainer, content: SettingsAuth });
        }

        if (configs.settings?.parentControl === true) {
            items.push({ type: SettingsItemContainer, content: SettingsParentalControl });
            items.push({ type: SettingsItemContainer, content: SettingsAgeRestriction });
        }

        // Information section (Terms, Privacy, Contact) moved from separate Info page into Settings
        const hasTerms = !!configs.settings?.terms;
        const hasPrivacy = !!configs.settings?.privacy;
        const hasContact =
            !!configs.settings?.email ||
            !!configs.settings?.providerEmail;

        if (hasTerms || hasPrivacy || hasContact) {
            if (hasTerms) {
                items.push({ type: SettingsItemContainer, content: SettingsTerms });
            }
            if (hasPrivacy) {
                items.push({ type: SettingsItemContainer, content: SettingsPrivacy });
            }
            if (hasContact) {
                items.push({ type: SettingsItemContainer, content: SettingsContact });
            }
        }

        const height = theme.settings.item.h * items.length;

        this.patch({
            h: height
        });

        this.List.patch({
            h: height,
            items
        });
    }

    onIndexChanged(indexData: any) {
        // @ts-ignore
        this.List.selected;
    }

    $listItemHover(e: any) {
        const index = this.List.items.findIndex((item: any) => item === e.parent);
        this.List.setIndex(index);

        // @ts-ignore
        this.signal("handleHover");

        return true;
    }
}
